<script setup lang="ts">
// ConfirmHost — единый хост окна подтверждения (монтируется один раз в App.vue).
// Рисует Modal из состояния useConfirm(): иконка danger/info, опциональный input,
// кнопки Отмена/Подтвердить (danger → красная). Esc/клик вне = отмена.
import { ref, watch } from 'vue';
import { Modal } from './index';
import { confirmState } from './useConfirm';
import { AlertTriangle, Info } from 'lucide-vue-next';

const { state, settle } = confirmState();
const inputValue = ref('');
const inputRef = ref<HTMLInputElement | null>(null);

watch(() => state.open, (v) => {
  if (v) {
    inputValue.value = '';
    setTimeout(() => inputRef.value?.focus(), 50);
  }
});

function doConfirm(): void {
  settle(true, state.options.input ? inputValue.value.trim() : undefined);
}
</script>

<template>
  <Modal :open="state.open" size="sm" @update:open="(v) => { if (!v) settle(false); }">
    <div class="ui-confirm">
      <div class="ui-confirm-icon" :class="state.options.danger ? 'is-danger' : 'is-info'">
        <AlertTriangle v-if="state.options.danger" :size="20" />
        <Info v-else :size="20" />
      </div>
      <div class="ui-confirm-text">
        <p class="ui-confirm-title">{{ state.options.title }}</p>
        <p v-if="state.options.message" class="ui-confirm-message">{{ state.options.message }}</p>
      </div>
    </div>
    <div v-if="state.options.input" class="ui-confirm-input-wrap">
      <label v-if="state.options.input.label" class="ui-modal-label">{{ state.options.input.label }}</label>
      <input
        ref="inputRef"
        v-model="inputValue"
        class="ui-modal-input"
        :placeholder="state.options.input.placeholder ?? ''"
        @keyup.enter="doConfirm"
      />
    </div>
    <template #footer>
      <button class="ui-modal-btn" :disabled="state.options.busy" @click="settle(false)">{{ state.options.cancelLabel }}</button>
      <button
        class="ui-modal-btn"
        :class="state.options.danger ? 'ui-modal-btn-danger' : 'ui-modal-btn-primary'"
        :disabled="state.options.busy"
        @click="doConfirm"
      >{{ state.options.confirmLabel }}</button>
    </template>
  </Modal>
</template>
